var _g, _g2, _g3, _g4, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFrameSticker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 266,
    height: 262,
    viewBox: "0 0 266 262",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3509_7748)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.7604 185.539C50.3794 188.155 67.1017 173.843 70.1108 153.574C73.1198 133.304 61.276 114.752 43.657 112.136C26.038 109.521 9.31565 123.832 6.30662 144.102C3.2976 164.372 15.1413 182.924 32.7604 185.539Z",
    fill: "#F2F4F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5756 122.818L42.094 123.969L36.9462 158.646L37.1983 159.041L52.6027 151.605L42.5756 122.818Z",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5756 122.818L24.6186 147.45L37.1984 159.041L39.6969 142.21L42.5756 122.818Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7459 162.089L36.5377 162.307L34.704 174.66L34.79 175.264L52.1594 154.66L36.7459 162.089Z",
    fill: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.79 175.264L36.7459 162.089L24.1657 150.501L34.79 175.264Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1984 159.041L52.6027 151.604L39.6969 142.21L37.1984 159.041Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6186 147.45L37.1983 159.041L39.6969 142.21L24.6186 147.45Z",
    fill: "#393939"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_3509_7748)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3509_7748)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.41 89.6588C198.465 92.6359 217.389 76.2423 220.856 52.8878C224.323 29.5333 210.978 8.34944 190.923 5.37228C170.868 2.39512 151.944 18.7887 148.477 42.1433C145.01 65.4978 158.355 86.6816 178.41 89.6588Z",
    fill: "#2775CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.628 55.6654C194.54 49.5197 191.687 46.9425 185.484 45.1245C181.064 43.7504 180.368 42.2115 180.733 39.7528C181.098 37.2942 182.841 35.9381 185.856 36.3858C188.571 36.7887 189.922 38.0661 190.285 40.812C190.358 41.3612 190.758 41.7794 191.21 41.8465L193.623 42.2047C194.226 42.2942 194.757 41.8346 194.861 41.1325L194.887 40.9567C194.857 37.0039 192.586 33.616 189.17 32.7501L189.796 28.5358C189.9 27.8333 189.526 27.2393 188.798 26.9517L186.536 26.6159C185.933 26.5263 185.402 26.986 185.121 27.8418L184.522 31.8804C179.894 31.9114 176.508 34.998 175.856 39.388C174.996 45.1827 177.673 47.9129 183.875 49.7313C187.967 51.2359 189.168 52.4909 188.751 55.3006C188.334 58.1103 185.936 59.7283 183.071 59.3031C179.15 58.721 178.08 56.5877 178.019 53.8866C177.972 53.1622 177.572 52.7435 177.12 52.6764L174.556 52.2958C173.953 52.2063 173.423 52.6659 173.318 53.3685L173.292 53.5442C173.243 58.0234 175.187 61.5423 180.033 63.1592L179.407 67.3735C179.303 68.0757 179.677 68.6696 180.405 68.9572L182.666 69.293C183.27 69.3826 183.8 68.9229 184.082 68.0675L184.707 63.8532C189.361 63.6464 192.924 60.4066 193.628 55.6654Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.249 71.4841C162.217 64.8217 158.453 48.6494 164.834 35.7773C168.19 28.738 174 23.8577 180.574 22.1415C181.229 21.88 181.609 21.398 181.739 20.5197L182.104 18.0615C182.208 17.359 181.985 16.7875 181.408 16.5226C181.257 16.5002 180.955 16.4554 180.778 16.6083C165.672 19.7497 155.198 36.3213 157.245 53.6744C158.499 63.9106 163.863 72.424 171.837 76.8382C172.389 77.2788 173.044 77.0173 173.299 76.3371C173.476 76.1842 173.502 76.0085 173.554 75.6574L173.919 73.1988C173.997 72.672 173.649 71.9028 173.249 71.4841ZM197.365 19.0707C196.814 18.6301 196.159 18.8916 195.904 19.5717C195.727 19.7251 195.701 19.9004 195.649 20.2519L195.284 22.7101C195.18 23.4126 195.528 24.1819 195.928 24.6005C206.96 31.2629 210.723 47.4352 204.343 60.3073C200.986 67.3466 195.176 72.2269 188.603 73.9431C187.948 74.2046 187.568 74.6866 187.438 75.5649L187.073 78.0231C186.968 78.7256 187.192 79.2972 187.769 79.562C187.92 79.5844 188.221 79.6292 188.398 79.4763C203.505 76.3349 213.979 59.7633 211.932 42.4102C210.703 31.9983 205.189 23.4625 197.365 19.0707Z",
    fill: "white"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_3509_7748)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3509_7748)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250.503 230.517C242.649 250.433 221.318 260.096 202.858 252.099C184.406 244.104 175.81 221.474 183.666 201.56C191.518 181.641 212.85 171.977 231.304 179.972C249.762 187.968 258.357 210.6 250.502 230.517L250.503 230.517L250.503 230.517Z",
    fill: "#F7931A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.72 212.899C235.194 207.881 231.968 204.587 227.27 202.012L229.913 195.31L226.132 193.673L223.559 200.198C222.565 199.767 221.541 199.349 220.523 198.933L223.114 192.365L219.336 190.728L216.692 197.427C215.867 197.091 215.056 196.759 214.272 196.42L214.28 196.399L209.067 194.138L207.35 198.495C207.35 198.495 210.164 199.647 210.096 199.682C211.627 200.346 211.747 201.521 211.566 202.412L208.555 210.047C208.66 210.093 208.796 210.157 208.943 210.249C208.817 210.194 208.683 210.135 208.544 210.076L204.325 220.771C204.053 221.262 203.442 221.969 202.372 221.507C202.402 221.574 199.624 220.316 199.624 220.316L196.951 224.862L201.871 226.993C202.786 227.391 203.68 227.798 204.563 228.187L201.891 234.966L205.668 236.603L208.312 229.896C209.34 230.369 210.34 230.812 211.32 231.236L208.686 237.91L212.467 239.548L215.136 232.782C221.647 235.142 226.777 235.342 229.869 229.141C232.36 224.148 231.012 220.855 227.773 218.357C230.44 218.102 232.647 216.574 233.721 212.9L233.72 212.899L233.72 212.899ZM222.715 225.101C220.719 230.167 212.908 226.108 210.345 225.001L213.888 216.021C216.45 217.132 224.799 219.818 222.715 225.101L222.715 225.101ZM225.953 211.669C224.135 216.276 217.643 212.835 215.509 211.91L218.721 203.766C220.856 204.69 227.848 206.862 225.953 211.669L225.953 211.669Z",
    fill: "white"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_3509_7748)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.739 224.215C167.619 229.118 205.905 196.056 211.254 150.369C216.602 104.681 186.988 63.67 145.108 58.7672C103.228 53.8644 64.9416 86.9268 59.5931 132.614C54.2446 178.301 83.8593 219.313 125.739 224.215Z",
    fill: "#F1253C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.739 160.874C106.22 160.345 102.655 158.754 100.044 156.1C97.4682 153.417 96.4377 149.875 96.9452 145.54C97.0536 144.614 97.2725 143.532 97.6094 142.23C98.4434 139.309 99.5594 135.817 100.961 131.721C104.872 120.64 112.211 115.73 122.949 116.987C125.861 117.328 128.438 118.166 130.615 119.528C132.8 120.823 134.434 122.625 135.521 124.899C136.612 127.14 136.988 129.7 136.651 132.578C136.551 133.439 136.332 134.52 135.995 135.822C134.989 139.428 133.899 142.956 132.673 146.335C130.676 151.837 127.902 155.839 124.297 158.268C120.726 160.668 116.199 161.513 110.739 160.874ZM112.604 152.036C114.727 152.284 116.598 151.799 118.243 150.616C119.919 149.437 121.255 147.48 122.225 144.709C123.562 140.908 124.624 137.611 125.42 134.752C125.672 133.909 125.868 133.027 125.976 132.1C126.418 128.328 124.849 126.232 121.24 125.81C119.116 125.561 117.215 126.043 115.54 127.222C113.895 128.405 112.589 130.365 111.619 133.136C110.596 135.834 109.533 139.131 108.363 143.086C108.115 143.896 107.923 144.746 107.814 145.672C107.335 149.507 108.964 151.61 112.604 152.036Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.742 163.197C135.317 163.148 135.029 162.98 134.822 162.654C134.678 162.301 134.66 161.93 134.771 161.507L147.353 122.058C147.468 121.601 147.723 121.262 148.122 121.007C148.491 120.748 148.87 120.659 149.264 120.705L164.4 122.477C168.616 122.97 171.871 124.324 174.198 126.508C176.551 128.729 177.534 131.629 177.112 135.235C176.992 136.261 176.743 137.339 176.399 138.439C174.901 143.094 172.579 146.378 169.4 148.32C166.281 150.269 162.237 150.936 157.262 150.354L149.588 149.456L145.388 162.75C145.242 163.203 145.018 163.545 144.619 163.801C144.25 164.059 143.871 164.149 143.477 164.103L135.742 163.197ZM158.66 141.83C160.268 142.018 161.687 141.715 162.982 140.894C164.308 140.076 165.255 138.812 165.859 137.071C166.061 136.39 166.196 135.769 166.258 135.239C166.397 134.048 166.172 133.082 165.608 132.379C165.049 131.643 163.965 131.181 162.418 130.999L155.594 130.2L152.139 141.066L158.66 141.83Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3509_7748",
    x: 0.858307,
    y: 107.4,
    width: 81.7008,
    height: 84.8747,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 7,
    dy: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.639216 0 0 0 0 0.67451 0 0 0 0 0.752941 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3509_7748"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3509_7748",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_3509_7748",
    x: 142.221,
    y: 0,
    width: 91.8908,
    height: 97.0311,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 7,
    dy: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.125156 0 0 0 0 0.360737 0 0 0 0 0.61651 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3509_7748"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3509_7748",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_3509_7748",
    x: 175.489,
    y: 172.206,
    width: 90.1897,
    height: 89.6603,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 7,
    dy: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.772549 0 0 0 0 0.454902 0 0 0 0 0.14902 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3509_7748"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3509_7748",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_3509_7748",
    x: 49.9088,
    y: 49.89,
    width: 183.029,
    height: 187.203,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 12,
    dy: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.628264 0 0 0 0 0.0634028 0 0 0 0 0.12578 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3509_7748"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3509_7748",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3509_7748"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 73.1717,
    height: 85.2102,
    fill: "white",
    transform: "translate(154.733) rotate(8.44387)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3509_7748"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72.5442,
    height: 77.8518,
    fill: "white",
    transform: "translate(186.921 172.206) rotate(8.44387)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrameSticker);
export default __webpack_public_path__ + "static/media/frame_sticker.824b108b9d1cea00698bceda2053b4c8.svg";
export { ForwardRef as ReactComponent };